import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { ElementAction, ElementFn } from '../../elements/elementAction';
import { Functions } from '../../types/types';
import { setLoading } from '../Loader/loaderAction';
import { AppState, updateAppState } from './appReducer';
import { WebSocketManager } from '../../services/WebSocketManager';

const init =
  (
    elFn: Partial<ElementFn<Functions>>
  ): ElementAction<Functions, { app: AppState }> =>
  async (dispatch, getState, { getAPI }) => {
    if (elFn) dispatch(updateAppState({ elFn }));
    const { user } = getState().app;
    if (user?.employeeId) return;
    const api = getAPI();
    dispatch(setLoading(true));
    const u = await api.getUser();
    const ss = await api.searchReferences({ nodeType: 'SystemSetting' } as any);
    if (ss?.length && ss[0]?.props?.cacheBuster) {
      api.setCacheBuster(ss[0].props.cacheBuster);
    }
    const webSocketUrl = ss?.[0]?.props?.webSocketUrl;
    if (webSocketUrl) {
      WebSocketManager.getInstance().setBaseUrl(webSocketUrl);
    }
    dispatch(updateAppState({ user: u.info }));
  };

const getUserInfo =
  (): ElementAction<Functions, { app: AppState }> =>
  async (dispatch, getState, { getAPI }) => {
    const { user } = getState().app;
    if (user?.employeeId) return;
    const api = getAPI();
    dispatch(setLoading(true));
    const u = await api.getUser();
    dispatch(updateAppState({ user: u.info }));
  };

export const useActions = () => {
  const dispatch: Dispatch<any> = useDispatch();
  return {
    init: (elFn: Partial<ElementFn<Functions>>) => {
      dispatch(init(elFn));
    },
    setAuthError: (authError: string) => {
      dispatch(updateAppState({ authError }));
    },
    setSessionExpiry: (sessionExpiry: { expired: boolean }) => {
      dispatch(updateAppState({ sessionExpiry }));
    },
    getUserInfo: () => dispatch(getUserInfo())
  };
};
